import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSlash = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.10833 4.10829L15.8917 15.8916M18.3333 9.99996C18.3333 14.6023 14.6024 18.3333 10 18.3333C5.39762 18.3333 1.66666 14.6023 1.66666 9.99996C1.66666 5.39759 5.39762 1.66663 10 1.66663C14.6024 1.66663 18.3333 5.39759 18.3333 9.99996Z",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSlash;
